/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 12:54 PM
 *
 */

import ToggleButton from 'components/layout/Sidebar/ToggleButton/ToggleButton';

export default ToggleButton;
